module.exports = __webpack_public_path__ + "static/media/din_certco_8C143_pdf.631a48ed.pdf";